import '../polyfill/fromEntries';

const initState = {
};

const sonda = (state = initState, action) => {
    switch (action.type) {
        case 'INIT_TEST':
            return Object.fromEntries(Object.entries(action.json).map((item, index) => {
                item[1] = {
                    done: false,
                    answers: {},
                };
                return item;
            }));
        case 'LOAD_TEST':
            return {
                ...action.test
            };
        case 'SAVE_ANSWER':
            return {
                ...state,
                [action.area]: {
                    ...state[action.area],
                    answers: {
                        ...state[action.area].answers,
                        [action.code]: {
                            id: action.answer.id,
                            text: action.answer.text,
                            first: action.first,
                            likeMore: action.answer.percent > 50,
                        }
                    }
                }
            };
        case 'MAKE_AREA_DONE':
            return {
                ...state,
                [action.area]: {
                    ...state[action.area],
                    done: true,
                }
            };
        default:
            return state
    }
};

export default sonda;


// WEBPACK FOOTER //
// ./sources/js/reducers/testReducer.js